<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">

  <p-toolbar>
    <ng-template #start>
      <div class="flex items-center gap-2 toolbar-menu">
        <p-selectButton [options]="modes" [(ngModel)]="selectedMode" (onChange)="modeToggle($event)"
          [allowEmpty]="false">
        </p-selectButton>

        @if (selectedMode !== 'minimum') {
          <p-selectButton [options]="resultsDisplay" [(ngModel)]="selectedResultDisplay"
            (onChange)="onSelectedResultDisplayUpdated($event)" [allowEmpty]="false">
          </p-selectButton>
        }

        @if (selectedResultDisplay === 'grid' && selectedMode == 'minimum') {
          <div>
            <p-checkbox size="small" inputId="detailsConnection" [(ngModel)]="includeCharacters"
              (onChange)="toggleCharacterView($event)" binary="true">
            </p-checkbox>
            <label class="pl-1" for="detailsConnection">Show Details</label>
          </div>
        }

        @if (selectedResultDisplay === 'plot' && selectedMode !== 'minimum') {
          <p-selectButton [options]="depthView" [(ngModel)]="selectedDepthView" (onChange)="depthViewToggle($event)"
            [allowEmpty]="false">
          </p-selectButton>
        }

        <app-single-load-results [loadCases]="loadCases" (loadCaseSelected)="setLoadCase($event)"
          [stateStore]="connectionSafetyFactorResultsStore" [signalRChange]="signalRChange">
        </app-single-load-results>
      </div>
    </ng-template>
  </p-toolbar>

  @if (selectedResultDisplay === 'plot') {
    <app-single-load-plot [yAxisTitle]="yAxisTitle" [xAxisTitle]="xAxisTitle" [columnDefs]="columnDefs" [data]="results"
      [selectedDepthView]="selectedDepthView" [depthUnit]="depthUnit" [plotName]="plotName"
      [plotTitle]="'Connection Safety Factor Results'" [singleLoadPlotStore]="connectionSafetyFactorResultsStore">
    </app-single-load-plot>
  }

  <app-single-load-grid [hidden]="selectedResultDisplay !== 'grid'" [rowData]="results"
    [columnDefinitions]="columnDefinitions" [selectedLoad]="selectedLoadCase"
    tableName="Connection Safety Factor Results" gridName="Connection Safety Factor Results" [mode]="selectedMode">
  </app-single-load-grid>

  <p-dialog [draggable]="false" [visible]="errorMsg != null" [closable]="false" appendTo="self">
    <i class="pi pi-exclamation-circle pr-1"></i>
    <label>{{ errorMsg }}</label>
    <br> <br>
  </p-dialog>

  @if (connectionSafetyFactorResults != null) {
    <app-perivis-validation [errors]="connectionSafetyFactorResults[0]?.errors" />
  }

</app-tool-loader>